import React from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import Toggle from "../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import FluentSelect from "../../../../Forms/FluentSelect";
import ChoiceGroup from "../../../../Forms/ChoiceGroup";

const globalOptions = [
    { key: false, text: 'Off' },
    { key: true, text: 'On' },
];

const InternationalFields = ({ model }) => (
    <>
        <Toggle
            name="international"
            label="Journal International Setting"
            onText="Journal is on for all countries"
            offText="Journal is only seen in the United States"
        />
        {model.international && ( 
        <div css={css`margin-top: 20px;`} >
            <ChoiceGroup 
                label="Journal Localization Setting" 
                name="isGlobal" 
                options={globalOptions} 
                required
            />
            <Text variant="small">
                If the journal is {model.isGlobal ? "on" : "off"} globally, then you can
                set the exceptions below.
            </Text>
            <FluentSelect
                label={model.isGlobal ? "Hide From" : "Show To"}
                options={model.countries}
                isMulti
                name={model.isGlobal ? 'excludeCountries' : 'includeCountries'}
                menuPlacement="auto"
            />
        </div>
        )}
    </>
);

export default InternationalFields;